import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

interface IImageSignRes {
    image_url: string
    upload_url: string
}

const apiGetImageSign = async (): Promise<ApiRes<IImageSignRes>> => {
    return await apiGet(API_URL, `imagesign`)
}

export const postUploadImage = async (file: File | Blob, resize: boolean = false, fit: boolean = false) => {
    const {data} = await apiGetImageSign()
    let img = new Image()
    img.src = await window.URL.createObjectURL(file)

    console.log(img)
    if (data) {
        const {image_url, upload_url} = data

        await fetch(upload_url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'image/png',
                'Cache-Control': 'public, max-age=604800',
            },
            body: file,
        })

        return {
            success: true,
            image_url: `${image_url}${
                resize === true
                    ? `?type=webp&width=${img.width}&height=${img.height}&quality=100`
                    : `${fit === true ? '?action=fit' : ''}`
            }`,
            size: {
                width: img.width,
                height: img.height,
            },
        }
    }

    return {
        success: false,
    }
}
